import { commonDate, dateTime, digitGroup } from 'src/helpers/index'

const initForm = {
  vendor: null,
  warehouse: null,
  sku: null,
  prices: []
}

export default function () {
  return {
    var_columns: [
      {
        name: 'nama1',
        field: (row) => {
          return row.variants || '-'
        },
        label: 'ID Varian',
        sortable: true,
        align: 'left',
        rowClass: 'text-left'
      },
      {
        name: 'nama2',
        field: (row) => {
          return row.label || '-'
        },
        label: 'Nama Varian',
        sortable: true,
        align: 'left',
        rowClass: 'text-left'
      },
      // {
      //   name: 'nama2',
      //   field: (row) => {
      //     return row.variants[1] ? row.variant[1] : '-'
      //   },
      //   label: 'Nama Varian 2',
      //   sortable: true,
      //   align: 'left',
      //   rowClass: 'text-left'
      // },
      // {
      //   name: 'nama3',
      //   field: (row) => {
      //     return row.variants[2] ? row.variant.variant3 : '-'
      //   },
      //   label: 'Nama Varian 3',
      //   sortable: true,
      //   align: 'left',
      //   rowClass: 'text-left'
      // },
      {
        name: 'stock',
        field: (row) => {
          if (row.stock > 999) {
            return 'Stok Tersedia'
          } else if (row.stock === null) {
            return 'Stok Habis'
          } else {
            return row.stock
          }
        },
        label: 'Stok',
        sortable: true,
        align: 'left',
        rowClass: 'text-left'
      },
      {
        name: 'cogs',
        field: (row) => {
          return row.cogs ? 'Rp. ' + digitGroup(row.cogs) : '-'
        },
        label: 'Harga COGS',
        sortable: true,
        align: 'left',
        rowClass: 'text-center'
      }
    ],

    pr_columns: [
      {
        name: 'name',
        field: (row) => {
          return row.label ? row.name + ' - ' + row.label : row.name || '-'
        },
        label: 'Nama Produk',
        sortable: true,
        align: 'left',
        rowClass: 'text-left'
      },
      // {
      //   name: 'variant',
      //   field: (row) => {
      //     return row.variant || '-'
      //   },
      //   label: 'Nama Varian',
      //   sortable: true,
      //   align: 'center',
      //   rowClass: 'text-center'
      // },
      {
        name: 'price',
        field: (row) => {
          return 'Rp. ' + digitGroup(row.price_before) || '-'
        },
        label: 'Harga Sebelum Promo',
        sortable: true,
        align: 'left',
        rowClass: 'text-left'
      },
      {
        name: 'price_promo',
        field: (row) => {
          return 'Rp. ' + digitGroup(row.price_after) || '-'
        },
        label: 'Harga Setelah Promo',
        sortable: true,
        align: 'left',
        rowClass: 'text-left'
      }
    ],
    table: {
      priceHistory: {
        columns: [
          {
            name: 'created_at',
            field: (row) => {
              // return row.created_at
              return `<div>${commonDate({
                date: row.created_at
              })}</div>
              <div class="text-caption text-grey-7">${dateTime(
                row.created_at
              )}</div>`
            },
            label: 'Tanggal Diubah',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'cogs',
            field: (row) => {
              return 'Rp ' + row.cogs ? digitGroup(row.cogs) : '-'
            },
            label: 'Perubahan Harga',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          },
          {
            name: 'actor',
            field: (row) => {
              return `<div>${row.user.name}</div>
              <div class="text-primary text-caption">${row.user.userRole.role.name}</div>`
            },
            label: 'Aktor',
            sortable: true,
            align: 'left',
            rowClass: 'text-left'
          }
        ]
      }
    },

    submission: {
      visibleColumns: [
        'productName',
        'item_category_name',
        'brand_name',
        'supplier_name',
        'created_at',
        'processed_at',
        'product_add_status'
      ],
      columns: [
        {
          name: 'productName',
          field: (row) => {
            return ` <strong>${row.productName || '-'}</strong> <p> ${
              row.variants || '-'
            }
            </p>`
          },
          label: 'Nama Produk',
          sortable: true,
          align: 'left'
        },
        {
          name: 'warehouseName',
          field: (row) => {
            return `<strong>${row.warehouseName || '-'}</strong> <p> ${
              row.supplierName || '-'
            }
            </p>`
          },
          label: 'Vendor',
          sortable: false,
          align: 'left',
          rowClass: 'td-width-small'
        },
        {
          name: 'submissionDate',
          field: 'submissionDate',
          label: 'Tgl. Pengajuan',
          sortable: false,
          align: 'left',
          commonDate: true
        },
        {
          name: 'initialPrice',
          label: 'Harga Awal',
          field: (row) => {
            let html = row.initialPrice
              ? 'Rp. ' + digitGroup(row.initialPrice)
              : '-'

            html += row.initialPriceUpdatedAt
              ? `<div class="text-caption text-grey-7">diubah ${commonDate({
                  useDayName: false,
                  date: row.initialPriceUpdatedAt
                })}</div>`
              : ''

            return html
          },
          sortable: true,
          align: 'right',
          rowClass: 'text-right'
        }
      ]
    },

    filterResponse: {},
    selectedRow: [],
    fetchedData: null,

    variantType: {
      value: null
    },

    formDefault: JSON.parse(JSON.stringify(initForm)),
    form: { ...initForm }
  }
}
